import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ToggleChatContainerE } from '@enums/attendances.enum';
import { ContactI } from '@interfaces/contact.interface';
import { ChatStoreService } from '@modules/chat/store/chat-store.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-call-notification-dialog',
  templateUrl: './call-notification-dialog.component.html',
  styleUrls: ['./call-notification-dialog.component.scss'],
})
export class CallNotificationDialogComponent implements OnInit {
  public number!: string;
  public contact?: ContactI;
  public DIDPrefix?: string;

  private isWhatsappCall = new BehaviorSubject<boolean>(true);
  public isWhatsappCall$ = this.isWhatsappCall.asObservable();

  private title = new BehaviorSubject<string>('');
  public title$ = this.title.asObservable();

  constructor(
    private dialogRef: MatDialogRef<any>,
    private chatStoreService: ChatStoreService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      number: string;
      contact?: ContactI;
      displayName?: string;
    }
  ) {}

  ngOnInit(): void {
    this.number = this.data.number;
    this.contact = this.data.contact;
    this.DIDPrefix = this.data.displayName;
    const isCallWhatsapp = this.number.startsWith('+');

    this.isWhatsappCall.next(isCallWhatsapp);

    if (isCallWhatsapp) {
      this.title.next(`${this.translateService.instant('RECEIVE_CALL_WHATSAPP')}`);
    } else {
      this.title.next(`${this.translateService.instant('RECEIVE_CALL')}`);
    }
  }

  public close() {
    this.dialogRef.close('HANGUP');
  }

  public confirm() {
    this.chatStoreService.setChatToggle(ToggleChatContainerE.DIALER);
    this.dialogRef.close('ANSWER');
  }

  public silence() {
    this.dialogRef.close('SILENCE');
  }
}
